module.exports = __webpack_public_path__ + "media/Images/icon-print-223f2073bd2cc44bedc22a28b8b7389b.svg";